import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { Card, CardCover } from "@mui/joy";
import "./BulkUpload.scss";
import images from "../../../assets/images";
import ButtonStyle from "../../../components/ButtonStyle/ButtonStyle";
import { AllowedPath } from "../AdminBulkUpload";
import { getDisplayType, getFileType } from "./Helper";
import { useLazyQuery, useMutation } from "@apollo/client";
import { UPLOAD_LIBRARY_IMAGE_ADMIN } from "../../ImageMaterial/api/ImageMaterialQuery";
import ToasterWithMessage from "../../../components/toaster";
import { GET_PRESIGNED_URL } from "../../../components/Popups/api/FileUploadQuery";
import { ALLOWED_MAP, CLASSROOM_S3_PATH, ERROR_MESSAGES, FETCH_POLICY, MATERIALS_TEXT, messages, MYLIBRARY_TEXTS, patterns } from "../../../utils/constants";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import UploadResultModal from "./UploadResultModal";
import { GET_OR_CREATE_BULKUPLOAD_CATEGORY, UPLOAD_SYNDICATED_VIDEOS_ADMIN } from "../../SyndicatedVideos/api/SyndicatedVideosQuery";
import { UPLOAD_PODCAST_ADMIN } from "../../PodCast/api/PodCastQueries";
import { UPLOAD_MATERIAL_ADMIN } from "../../TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery";
import { UPLOAD_QUESTIONS_BANK_ADMIN } from "../../QuestionBank/api/QuestionsBankQuery";
import ConfirmationPopup from "../../../components/ConfirmationPopup/ConfirmationPopup";
import { trackButtonClick } from "../../../firebase/analyticsHelper";
import { ButtonClickEvents } from "../../../firebase/constants/events";
import { getMaxBatchSize } from "../../../utils/helper";
import UploadToaster from "../../../components/Popups/UploadProgressBar/UploadProgressPopup";
import { useAppSelector } from "../../../redux/app/hooks";

interface BulkUploadProps {
  selectedPath: AllowedPath;
  selectedClassIds: string[];
  selectedSubject: string;
  setHasSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
  ErrorInFields: string | null;
  videoCategoryId?: string | null;
  descriptionValue?: string | null;
  authorName?: string | null;
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
}

export interface UploadResult {
  filename: string;
  duplicates: number;
  classrooms_failed: { c_id: string; c_name: string }[];
  classrooms_updated: { c_id: string; c_name: string }[];
  skipped_no_subject: number;
  classrooms_considered: { c_id: string; c_name: string }[];
  classrooms_failed_count: number;
  classrooms_updated_count: number;
  classrooms_total_considered: number;
}
export interface AdminBulkFileState {
  uploadFileName: string;
  progress: number;
  success?: boolean | null;
  errorMessage?: string | null;
}

const BulkUpload: FunctionComponent<BulkUploadProps> = ({
  selectedPath,
  selectedClassIds,
  selectedSubject,
  setHasSubmitted,
  ErrorInFields,
  videoCategoryId,
  descriptionValue,
  authorName,
  files,
  setFiles
}) => {
  const [dragActive, setDragActive] = useState(false);
  const {
    podcast,
    pdfImg,
    csvImg,
    docsImg,
    excelPreview,
    powerpoint,
    epub,
    BulkUplodIcon,
    ShareGif
  } = images;
  const { error, success } = ToasterWithMessage();
  const [loading, setLoading] = useState(false);
  const [uploadResults, setUploadResults] = useState<UploadResult[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [isShareMaterial, setIsShareMaterial] = useState<boolean | undefined>(undefined);

  // upload progress states (same as common bulk upload)
const [uploaded, setuploaded] = useState(false);
const [uploadFailed, setUploadFailed] = useState(false);
const [uploadFileName, setUploadFileName] = useState<string>("");
const [uploadProgress, setUploadProgress] = useState(0);

const [FilesStatusData, setFilesStatusData] = useState<AdminBulkFileState[]>([]);
const [totalProgress, setTotalProgress] = useState(0);

const [successCount, setSuccessCount] = useState(0);
const [failureCount, setFailureCount] = useState(0);
const [bulkCategoryId, setBulkCategoryId] = useState<string>("");
const profile = useAppSelector((state) => state?.auth?.adminProfile);
const role = useAppSelector((state) => state.auth.role);
const wrapperRef = useRef<HTMLDivElement | null>(null);
const [isOverflowing, setIsOverflowing] = useState(false);


  let folderName: string = "";
  console.log(videoCategoryId, "videoid");


  const handleAllowedFile = (file: File, selectedPath: string) => {
    const rule = ALLOWED_MAP[selectedPath];
    if (!rule) {
      return true; // fallback
    }
    return rule.mimes.includes(file.type);
  };


  const handleFiles = (uploadedFiles: FileList | null) => {
    if (!uploadedFiles) {
      return;
    }

    if (!selectedPath || !selectedSubject) {
      error("Please select both a path and a subject before uploading file(s).");
      return;
    }

    const hasInvalid = Array.from(uploadedFiles).some(
      (file) => !handleAllowedFile(file, selectedPath)
    );

    if (hasInvalid) {
      error(ERROR_MESSAGES[selectedPath]);
      return;
    }

    const arrayData = Array.from(uploadedFiles);
    let filteredFiles = [...arrayData];

          const duplicatesInDrop: any = [];
          const seen = new Set();

          filteredFiles.forEach((file) => {
            const key = `${file.name}-${file.size}-${file.lastModified}`;
            if (seen.has(key)) {
              duplicatesInDrop.push(file.name);
            } else {
              seen.add(key);
            }
          });

          // Remove duplicates found in this drop
          filteredFiles = filteredFiles.filter((file) => {
            const key = `${file.name}-${file.size}-${file.lastModified}`;
            return seen.has(key);
          });

          // Toast for within-drop duplicates
          if (duplicatesInDrop.length > 0) {
            error(`Duplicate file(s) are skipped`);
          }

          const existingNames = new Set(files.map((f) => f.name));

          const duplicatesWithExisting = filteredFiles.filter((file) =>
            existingNames.has(file.name)
          );

          if (duplicatesWithExisting.length > 0) {
            error(`Duplicate file(s) are skipped`);
          }

          // Remove duplicates with existing selected list
          filteredFiles = filteredFiles.filter((file) => !existingNames.has(file.name));

          // Stop if nothing left
          if (filteredFiles.length === 0) {
            return;
          }

          console.log("[filtered] filteredFiles after duplicate removal", filteredFiles);


    const newFilesArray = Array.from(filteredFiles);

    // Max file count check
    const totalFilesCount = files.length + newFilesArray.length;
    if (totalFilesCount > 10) {
      error("You can upload maximum 10 files only.");
      return;
    }

    //Total batch size check
    const existingTotalSize = files.reduce((sum, f) => sum + f.size, 0);
    const incomingTotalSize = newFilesArray.reduce((sum, f) => sum + f.size, 0);
    const finalTotalSize = existingTotalSize + incomingTotalSize;

    const maxAllowedBatchSize = getMaxBatchSize(selectedPath);

    if (finalTotalSize > maxAllowedBatchSize) {
      error(
        `Total upload size exceeds allowed limit of ${
          Math.round(maxAllowedBatchSize / (1024 * 1024))
        } MB`
      );
      return;
    }

    const newFiles = Array.from(filteredFiles).filter((file) => {
      // Check file name validity first
      const fileNameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
      
      if (!patterns.fileNameLengthRegex.test(fileNameWithoutExtension)) {
        error(messages.fileNameLength);
        return false;
      }
      
      // 🔹 Run validations using your existing patterns & messages
      if (!patterns.fileNameRegex.test(fileNameWithoutExtension)) {
        error(messages.inBulkUploadfileName);
        return false;
      }

      if (patterns.consecutiveSpecialCharsRegex.test(fileNameWithoutExtension)) {
        error(messages.consecutiveSpecialChars);
        return false;
      }

      if (!patterns.filenameAtleast1Alpha.test(fileNameWithoutExtension)) {
        error(messages.filenameAtlease1Alpha);
        return false;
      }

      let maxAllowedSize = 0;

      if (selectedPath === MYLIBRARY_TEXTS?.IMAGES_TEXT) {
        maxAllowedSize = 5 * 1024 * 1024; // 5MB
      } else if (
        selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_EXAM_GUIDE_TEXT ||
        selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_LEARNING_MATERIALS_TEXT ||
        selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_QUESTION_BANK_TEXT
      ) {
        maxAllowedSize = 25 * 1024 * 1024; // 25MB
      } else if (selectedPath?.includes(MYLIBRARY_TEXTS?.PODCAST_TEXT)) {
        maxAllowedSize = 100 * 1024 * 1024; // 100MB
      } else if (selectedPath?.includes(MYLIBRARY_TEXTS?.VIDEOS_TEXT)) {
        maxAllowedSize = 500 * 1024 * 1024; // 500MB
      }

      if (file.size > maxAllowedSize) {
        error(
          `${file.name} exceeds the max allowed size of ${
            maxAllowedSize / (1024 * 1024)
          } MB`
        );
        return false;
      }

      return true;
    });

    if (newFiles.length > 0) {
      setFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const bucketname = process.env.REACT_APP_MEDIA_BUCKET_NAME;
  const region = process.env.REACT_APP_REGION;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFiles(e.target.files);
    e.target.value = "";
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragActive(false);
    handleFiles(e.dataTransfer.files);
    e.dataTransfer.clearData();
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => setDragActive(false);

  const handleRemove = (index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    setFiles([]);
  }, [selectedPath]);

  // utils/filePreview.ts
  const getFilePreview = (file: File): string | "video" | "audio" => {
    if (file.type.startsWith("video/")) {
      return "video";
    }
    if (file.type.startsWith("audio/")) {
      return podcast;
    }
    switch (file.type) {
      case "application/pdf":
        return pdfImg;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return docsImg;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
        return excelPreview;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return powerpoint;
      case "application/epub+zip":
        return epub;
      default:
        if (file.type.startsWith("text/")) {
          return csvImg;
        }
        if (file.type.startsWith("image/")) {
          return URL.createObjectURL(file);
        }
        return pdfImg;
    }
  };

  const [getPreSignedUrl] = useLazyQuery(GET_PRESIGNED_URL, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {},
    onError: (err) => {
      // error("Something went wrong!")
    },
  });

   const [getOrCreateBulkUploadCategory] = useMutation(GET_OR_CREATE_BULKUPLOAD_CATEGORY, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      console.log("data from get or create category", data);
    },
    onError:(err) => {
        error(err?.message);
     }
   });
   
  const [uploadImageMaterialAdmin] = useMutation(UPLOAD_LIBRARY_IMAGE_ADMIN, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      console.log(data);
    },
    onError: (err) => {
      error(err?.message);
    },
  });

  const [uploadSyndicatedvideoAdmin] = useMutation(
    UPLOAD_SYNDICATED_VIDEOS_ADMIN,
    {
      fetchPolicy: FETCH_POLICY,
      onCompleted: (data) => {
        console.log(data);
      },
      onError: (err) => {
        error(err?.message);
      },
    }
  );

  const [uploadPodcastAdmin] = useMutation(UPLOAD_PODCAST_ADMIN, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      console.log(data);
    },
    onError: (err) => {
      error(err.message);
    },
  });

  const [uploadTeachingMaterialAdmin] = useMutation(UPLOAD_MATERIAL_ADMIN, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      console.log(data);
    },
    onError: (err) => {
      error(err?.message);
    },
  });

  const [uploadQuestionBankAdmin] = useMutation(UPLOAD_QUESTIONS_BANK_ADMIN, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      console.log(data);
    },
    onError: (err) => {
      error(err.message);
    },
  });

  const handleBulkUplad = async () => {
    trackButtonClick(ButtonClickEvents?.ADMIN_UPLOAD_CLICK, {
      description: "Admin user clicks the bulk upload button",
    });
    setHasSubmitted(true);
    if (files.length === 0 || selectedClassIds.length === 0 || ErrorInFields) {
      return;
    }

    setuploaded(true);
    setUploadFailed(false);
    setUploadProgress(0);
    setTotalProgress(0);
    setFilesStatusData([]);
    setSuccessCount(0);
    setFailureCount(0);
    setLoading(true);
    try {
      if(selectedPath === MYLIBRARY_TEXTS?.IMAGES_TEXT) {
        folderName = "images";
      } else {
        folderName = "materials";
      }

      // Prepare all files for upload in parallel
      const uploadPromises = files.map(async (file) => {
      return (async () => {
        try{
          // initialize item
        setFilesStatusData(prev => [
          ...prev,
          { uploadFileName: file.name.split(".").slice(0, -1).join("."), progress: 0 }
        ]);

        const sanitizedFileName = file.name.replace(/ /g, "_");
        const extension = file.name.slice(file.name.lastIndexOf("."));
        const newFileName = `${CLASSROOM_S3_PATH}${folderName}/${sanitizedFileName}-${Date.now()}${extension}`;

        // 1️⃣ Get presigned URL
        const { data } = await getPreSignedUrl({
          variables: { input: { key: newFileName } },
        });
        const { preSignedUrl } = data.getUploadPresignedUrl;

        // 2️⃣ Upload image to S3
        await axios.put(preSignedUrl, file, {
          headers: { "Content-Type": file.type },
          onUploadProgress: (progressEvent:any) => {
            if (progressEvent && progressEvent.loaded && progressEvent.total) {
                  const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                  setFilesStatusData((prev) => {
                    const updated = prev.map((p) =>
                      p.uploadFileName === file.name.split(".").slice(0, -1).join(".")
                        ? { ...p, progress: percentCompleted }
                        : p
                    );
                    // 🧠 compute total progress cleanly
                    const total = updated.reduce(
                      (acc, f) => acc + (f.progress ?? 0),
                      0
                    );
                    const avg = Math.round(total / updated.length);
                    setTotalProgress(avg);

                    return updated;
                  });
                  if(setFilesStatusData?.length === 1){
                    console.log("percentCompleted single file", percentCompleted);  
                    if(setUploadProgress){
                      setUploadProgress(percentCompleted);
                    }
                  }
                }
          }
        });

        setFilesStatusData(prev =>
          prev.map(f =>
            f.uploadFileName === file.name.split(".").slice(0, -1).join(".")
              ? { ...f, success: true }
              : f
          )
        );

        setSuccessCount(prev => prev + 1);

        // 3️⃣ Extract S3 key
        const s3Key = preSignedUrl
          .split("?")[0]
          .split(`https://${bucketname}.s3.${region}.amazonaws.com/`)[1];
        const fileNameWithoutExtension = file.name
          .split(".")
          .slice(0, -1)
          .join(".");
        // Return file info for mutation
        return {
          filename: fileNameWithoutExtension,
          filepath: s3Key,
          filesize: file.size,
          isClassroom: isShareMaterial,
          // coverImagePath: null,

          ...((selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_LEARNING_MATERIALS_TEXT ||
            selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_EXAM_GUIDE_TEXT) && {
            filetype: getFileType(file.type),
          }),

        ...(files.length > 1
      ? {
          ...(selectedPath === MYLIBRARY_TEXTS?.PODCAST_TEXT && {fileDescription: `Multiple File Upload by ${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : profile?.getCurrentUser?.nodes?.[0]?.uFullName ? profile?.getCurrentUser?.nodes?.[0]?.uFullName : role}`}),
          ...(selectedPath === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT && {category_id: bulkCategoryId}), // Bulk Upload category (Animation - Angular)
          ...(selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_EXAM_GUIDE_TEXT && {authorName: `Multiple File Upload by ${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : profile?.getCurrentUser?.nodes?.[0]?.uFullName ? profile?.getCurrentUser?.nodes?.[0]?.uFullName : role}`}),
        }: {
          ...(descriptionValue && { fileDescription: descriptionValue }),

          ...(videoCategoryId?.trim() && {
            category_id: videoCategoryId.trim(),
          }),

          ...(selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_EXAM_GUIDE_TEXT && {
            authorName: authorName,
          }),
        })
        };
      } catch (err: any) {
            setFilesStatusData(prev =>
              prev.map(f =>
                f.uploadFileName === file.name.split(".").slice(0, -1).join(".")
                  ? { ...f, success: false, errorMessage: err.message }
                  : f
              )
            );
            setFailureCount(prev => prev + 1);
            throw err;
          }
        })();
      });

      const uploadedFiles = await Promise.allSettled(uploadPromises);

      const successfulFiles = uploadedFiles
      .filter((r): r is PromiseFulfilledResult<any> => r.status === "fulfilled")
      .map(r => r.value);

      const failedFiles = uploadedFiles
      .filter((r): r is PromiseRejectedResult => r.status === "rejected")
      .map(r => r.reason);

      if (successfulFiles.length === 0 || (failedFiles?.length === files.length)) {
        console.log("mutation skipped as all uploads failed");
        setUploadFailed(true);
        return;
      }

      let response;
      let results;

      if (selectedPath === MYLIBRARY_TEXTS?.IMAGES_TEXT) {
        response = await uploadImageMaterialAdmin({
          variables: {
            files: successfulFiles,
            classroomIds: selectedClassIds,
            subjectId: selectedSubject,
          },
        });
        if(response?.data?.uploadMylibraryImagesBySchoolAdmin?.result) {
        results = response?.data?.uploadMylibraryImagesBySchoolAdmin?.result;
        }
      } else if (selectedPath === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT) {
        response = await uploadSyndicatedvideoAdmin({
          variables: {
            files: successfulFiles,
            classroomIds: selectedClassIds,
            subjectId: selectedSubject,
          },
        });
        if(response?.data?.uploadMylibrarySyndicatedVideosBySchoolAdmin?.result) {
        results =
          response?.data?.uploadMylibrarySyndicatedVideosBySchoolAdmin?.result;
        }
      } else if (selectedPath === MYLIBRARY_TEXTS?.PODCAST_TEXT) {
        response = await uploadPodcastAdmin({
          variables: {
            files: successfulFiles,
            classroomIds: selectedClassIds,
            subjectId: selectedSubject,
          },
        });
        if(response?.data?.uploadMylibraryPodcastsBySchoolAdmin?.result) {
        results = response?.data?.uploadMylibraryPodcastsBySchoolAdmin?.result;
        }
      } else if (selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_LEARNING_MATERIALS_TEXT) {
        response = await uploadTeachingMaterialAdmin({
          variables: {
            files: successfulFiles,
            classroomIds: selectedClassIds,
            subjectId: selectedSubject,
            typeName: MATERIALS_TEXT,
          },
        });
        if(response?.data?.uploadMylibraryEbooksBySchoolAdmin?.result) {
        results = response?.data?.uploadMylibraryEbooksBySchoolAdmin?.result;
        }
      } else if (selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_EXAM_GUIDE_TEXT) {
        response = await uploadTeachingMaterialAdmin({
          variables: {
            files: successfulFiles,
            classroomIds: selectedClassIds,
            subjectId: selectedSubject,
            typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
          },
        });
        if(response?.data?.uploadMylibraryEbooksBySchoolAdmin?.result) {
        results = response?.data?.uploadMylibraryEbooksBySchoolAdmin?.result;
        }
      } else if (selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_QUESTION_BANK_TEXT) {
        response = await uploadQuestionBankAdmin({
          variables: {
            files: successfulFiles,
            classroomIds: selectedClassIds,
            subjectId: selectedSubject,
          },
        });
        if(response?.data?.uploadQuestionBanksByAdmin?.result) {
        results = response?.data?.uploadQuestionBanksByAdmin?.result;
        }
      }

      if (results) {
        setUploadResults(results);

        let hasFailures;
        if(selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_QUESTION_BANK_TEXT) {
          hasFailures = results.some(
            (res: { classroomsFailed: any[] }) =>
              res.classroomsFailed.length > 0
          );
        }else {
          hasFailures = results.some(
            (res: { classrooms_failed: any[] }) =>
              res.classrooms_failed.length > 0
          );
        }
        

        if (hasFailures) {
          setIsModalOpen(true);
        } else {
          success("File uploaded Successfully!");
        }
      }

      // 5️⃣ Clear files and show success
      setFiles([]);
      console.log("All images uploaded successfully!");
    } catch (err: any) {
      setUploadFailed(true);
      console.error("Bulk upload failed:", err);
      error(err?.message);
    } finally {
      setLoading(false); // stop loading
      setIsShareMaterial(undefined);
    }
  };

  const onYesButtonClick = () => {
    setIsShareMaterial(true);
    setOpenConfirmationPopup(false);
  }

  const onNoButtonClick = () => {
    setIsShareMaterial(false);
    setOpenConfirmationPopup(false);
  }

  const getDefaultValues = async () => {
  try {
    const response = await getOrCreateBulkUploadCategory({
      variables: {
        subjectId: selectedSubject,
      }
    });
    
    if(response){
      const catId = response?.data?.getOrCreateBulkUploadCategory?.scId;
      if (catId) {
        setBulkCategoryId(catId);
      }
    }
  } catch (err: any) {
    console.log("error in get or create category", err?.message);
  }
};

  useEffect(() => {
    if(isShareMaterial !== undefined) {
    handleBulkUplad();
    }
  }, [isShareMaterial]);

  useEffect(() => {
    // compute success and failure count
    let successCountValue = 0;
    let failureCountValue = 0;
    FilesStatusData.forEach(f => {
      if(f.success === true){
        successCountValue += 1;
      } else if(f.success === false){
        failureCountValue += 1;
      }
    });
    setSuccessCount(successCount);
    setFailureCount(failureCount);
    
  }, [files, FilesStatusData, successCount, failureCount, totalProgress, uploadProgress]);


    useEffect(() => {
      if(files?.length > 0 && !bulkCategoryId && selectedSubject && (selectedPath === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT)) {
        getDefaultValues();
      }
    }, [files, selectedSubject]);

useEffect(() => {
  const el = wrapperRef.current;
  if (!el) {
    return;
  }
  const checkOverflow = () => {
    setIsOverflowing(el.scrollWidth > el.clientWidth);
  };

    // Listen to window resize
  window.addEventListener("resize", checkOverflow);

  // Cleanup
  return () => {
    window.removeEventListener("resize", checkOverflow);
  };
}, [files]);

  return (
    <>
      <div className="bulk-upload">
        <div
          className={`dropzone ${dragActive ? "active" : ""} ${
            files.length > 0 ? "filesupload" : ""
          } `}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
        >
          {/* Previews inside CardCover */}
          {files.length > 0 && (
            <div className={`card-preview-wrapper ${isOverflowing ? 'overflowing' : ''}`} ref={wrapperRef}>
              {files.map((file, index) => { 
                const url = URL.createObjectURL(file);
                return (
                  <Card key={index} className="preview-card">
                    <CardCover>
                      {file.type.startsWith("video/") ? (
                        <video autoPlay loop muted>
                          <source src={url} />
                        </video>
                      ) : (
                        <img
                          className="previewImage"
                          src={getFilePreview(file)}
                          alt={file.name}
                        />
                      )}
                    </CardCover>

                    <button
                      className="remove-btn"
                      onClick={() => handleRemove(index)}
                    >
                      ✖
                    </button>
                  </Card>
                );
              })}
            </div>
          )}

          {/* File input */}
          {files.length <= 0 && (
            <div className="upload-icon">
              <img src={BulkUplodIcon} alt="" className="upload-img" />
            </div>
          )}

          <input
            type="file"
            multiple
            accept={
              selectedPath === MYLIBRARY_TEXTS?.IMAGES_TEXT
                ? "image/jpeg,image/png,image/svg+xml,image/jpg"
                : selectedPath?.includes(MYLIBRARY_TEXTS?.VIDEOS_TEXT)
                ? "video/mp4"
                : selectedPath === MYLIBRARY_TEXTS?.PODCAST_TEXT
                ? "audio/mpeg,audio/wav,audio/ogg"
                : selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_LEARNING_MATERIALS_TEXT
                ? ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.epub"
                : selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_QUESTION_BANK_TEXT
                ? ".csv"
                : selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_EXAM_GUIDE_TEXT
                ? ".pdf"
                : ".pdf,.doc,.docx,.txt" // fallback
            }
            onChange={handleChange}
            id="fileUpload"
            hidden
          />

          <label htmlFor="fileUpload" className="upload-label">
            Drag & drop{" "}
            <span style={{ color: "#0B74BB" }}>
              {getDisplayType(selectedPath)}
            </span>{" "}
            Here
          </label>
          <span className="browse">
            or{" "}
            <label className="materials" htmlFor="fileUpload">
              browse files
            </label>{" "}
            on your computer
          </span>
        </div>
      </div>
      <div className="upload-button-bulk">
        <ButtonStyle
          deleteBtn={
            loading ? <CircularProgress size={20} color="inherit" /> : undefined
          }
          text="Upload"
          disableButton={
            selectedClassIds.length <= 0 ||
            files.length <= 0 ||
            loading ||
           (files?.length === 1 && ( !!ErrorInFields ||
            (selectedPath === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT && !videoCategoryId) ||
            (selectedPath === MYLIBRARY_TEXTS?.PODCAST_TEXT && !descriptionValue) ||
            (selectedPath === MYLIBRARY_TEXTS?.EBOOK_PREFIX_EXAM_GUIDE_TEXT && !authorName)))
          }
          width="100%"
          onClick={() => setOpenConfirmationPopup(true)}
        />
      </div>
      <UploadResultModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        results={uploadResults}
        page={"BulkUploadAdmin"}
      />
      {uploaded && 
      <UploadToaster 
          successCount = {successCount} 
          failureCount={failureCount} 
          uploaded={uploaded} 
          FilesStatusData = {FilesStatusData} 
          setFilesStatusData = {setFilesStatusData} 
          totalProgress = {totalProgress} 
          setTotalProgress = {setTotalProgress} 
          setuploaded={setuploaded} 
          uploadProgress={uploadProgress} 
          setUploadProgress={setUploadProgress} 
          fileName={uploadFileName} 
          setUploadFileName={setUploadFileName} 
          uploadFailed={uploadFailed} 
          setUploadFailed={setUploadFailed} 
        />}

      <ConfirmationPopup
          open={openConfirmationPopup}
          message={messages.multipleShareClassesMessage}
          gifData={ ShareGif }
          yesButtonFunctionality={onYesButtonClick}
          noButtonFunctionality={onNoButtonClick}
          messageWidth={'210px'}
      />
    </>
  );
};

export default BulkUpload;
